import styled, { keyframes } from 'styled-components';

const dash = keyframes`
  0% {
    stroke-dashoffset: var(--dashoffset);
  }
  100% {
    stroke-dashoffset: var(--dashoffsetEnd);
  }
`;
const Svg = styled.svg`
  position: absolute;
  inset: 0;
  path {
    stroke-dasharray: var(--dashoffset);
    animation: ${dash} 1s cubic-bezier(0.35, -0.01, 0.3, 0.99) forwards;
  }
`;
const refCallback = (ref: any) => {
  const length = ref?.getTotalLength();
  ref?.style.setProperty('--dashoffset', length);
  ref?.style.setProperty('--dashoffsetEnd', length * -1);
};

type Props = {
  fieldUrl: string;
  completion: number;
};
export const Stadium = ({ fieldUrl, completion }: Props) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 1467 1954"
      fill="none"
      preserveAspectRatio="xMidYMid slice"
    >
      <image
        opacity="1"
        href={fieldUrl!}
        x="1"
        y="-3"
        width="100%"
        height="100%"
        style={{
          /** Shouldn't be a default value because the prop is used as a key */
          filter: `grayscale(${100 - (completion || 0.2) * 100}%)`,
          opacity: completion || 0.2,
        }}
      />
      {/* Necessary to start the animation on completion change */}
      <g key={completion}>
        <path
          ref={refCallback}
          d="M737 715C662.5 713.5 619 757.5 618 786.5C557.2 786.5 380.5 786.5 300.5 786.5L414.5 457.5H737"
          stroke="var(--c-nd-400)"
          strokeWidth="1"
          filter="url(#blur)"
        />
        <path
          ref={refCallback}
          d="M737 715C799 717.5 845 746.5 850.5 787L1169 786.5L1055 457.5H737"
          stroke="var(--c-nd-400)"
          strokeWidth="1"
          filter="url(#blur)"
        />
        <path
          ref={refCallback}
          d="M737 871.5C783 870.5 850.5 849 850.5 787C922.9 787 1093.67 786.5 1169 786.5L1449 1588.5H824.5"
          stroke="var(--c-nd-400)"
          strokeWidth="1"
          filter="url(#blur)"
        />

        <path
          ref={refCallback}
          d="M737 871.5C663 872 613.5 833.5 618 786.5C577.2 786.5 388.167 786.5 300.5 786.5L13 1588.5H637.5"
          stroke="var(--c-nd-400)"
          strokeWidth="1"
          filter="url(#blur)"
        />
      </g>
      <defs>
        <filter id="blur">
          <feFlood floodOpacity="0" result="in2" />
          <feBlend mode="normal" in="SourceGraphic" in2="in2" />
          <feGaussianBlur stdDeviation="1" />
        </filter>
      </defs>
    </Svg>
  );
};
